import { serializeQuery, type QueryObject } from '@/shared/lib/serializeQuery';
import type { Hotel } from '@/shared/model';
import type { SearchCriteria, PartialSearchCriteria, Selection } from '../model/types';
import { block } from './toUrl/block';
import { checkInDateRange } from './toUrl/checkInDateRange';
import { directFlight } from './toUrl/directFlight';
import { fromCity } from './toUrl/fromCity';
import { meals } from './toUrl/meals';
import { nightRange } from './toUrl/nightRange';
import { touristGroup } from './toUrl/touristGroup';

export function getSingleHotelId(destination: Selection<unknown, unknown, Partial<Hotel>> | null): number | null {
  if (destination?.kind === 'hotels' && destination.hotels.length === 1) {
    return destination.hotels[0].id ?? null;
  }

  return null;
}

export function getHotelUrl(criteria: SearchCriteria | PartialSearchCriteria, otherCriteria: QueryObject = {}): string {
  return serializeQuery({
    ...fromCity(criteria),
    ...checkInDateRange(criteria),
    ...nightRange(criteria),
    ...touristGroup(criteria),
    ...directFlight(criteria),
    ...block(criteria),
    ...meals(criteria),
    ...otherCriteria,
  });
}
